// Đăng ký sử dụng
export const GET_LIST_REGISTRY_INVOICES = "GET_LIST_REGISTRY_INVOICES";
export const GET_LIST_REGISTRY_INVOICES_SUCCESS =
  "GET_LIST_REGISTRY_INVOICES_SUCCESS";
export const GET_LIST_REGISTRY_INVOICES_FAIL =
  "GET_LIST_REGISTRY_INVOICES_FAIL";
export const RESET_LIST_REGISTRY_INVOICES = "RESET_LIST_REGISTRY_INVOICES";

// Ủy quyền lập hóa đơn
export const GET_LIST_REGISTRY_DELEGATE = "GET_LIST_REGISTRY_DELEGATE";
export const GET_LIST_REGISTRY_DELEGATE_SUCCESS =
  "GET_LIST_REGISTRY_DELEGATE_SUCCESS";
export const GET_LIST_REGISTRY_DELEGATE_FAIL =
  "GET_LIST_REGISTRY_DELEGATE_FAIL";
export const RESET_LIST_REGISTRY_DELEGATE = "RESET_LIST_REGISTRY_DELEGATE";

// Đề nghị cấp HDDT có mã
export const GET_LIST_REQUEST_INVOICE_CODE = "GET_LIST_REQUEST_INVOICE_CODE";
export const GET_LIST_REQUEST_INVOICE_CODE_SUCCESS =
  "GET_LIST_REQUEST_INVOICE_CODE_SUCCESS";
export const GET_LIST_REQUEST_INVOICE_CODE_FAIL =
  "GET_LIST_REQUEST_INVOICE_CODE_FAIL";
export const RESET_LIST_REQUEST_INVOICE_CODE =
  "RESET_LIST_REQUEST_INVOICE_CODE";

// Chi tiết Đăng ký sử dụng
export const GET_DETAIL_REGISTRY_INVOICES = "GET_DETAIL_REGISTRY_INVOICES";
export const GET_DETAIL_REGISTRY_INVOICES_SUCCESS =
  "GET_DETAIL_REGISTRY_INVOICES_SUCCESS";
export const GET_DETAIL_REGISTRY_INVOICES_FAIL =
  "GET_DETAIL_REGISTRY_INVOICES_FAIL";
export const RESET_DETAIL_REGISTRY_INVOICES = "RESET_DETAIL_REGISTRY_INVOICES";

// Chi tiết Ủy quyền lập hóa đơn
export const GET_DETAIL_REGISTRY_DELEGATE = "GET_DETAIL_REGISTRY_DELEGATE";
export const GET_DETAIL_REGISTRY_DELEGATE_SUCCESS =
  "GET_DETAIL_REGISTRY_DELEGATE_SUCCESS";
export const GET_DETAIL_REGISTRY_DELEGATE_FAIL =
  "GET_DETAIL_REGISTRY_DELEGATE_FAIL";
export const RESET_DETAIL_REGISTRY_DELEGATE = "RESET_DETAIL_REGISTRY_DELEGATE";

// Chi tiết Đề nghị cấp HDDT có mã
export const GET_DETAIL_REQUEST_INVOICE_CODE =
  "GET_DETAIL_REQUEST_INVOICE_CODE";
export const GET_DETAIL_REQUEST_INVOICE_CODE_SUCCESS =
  "GET_DETAIL_REQUEST_INVOICE_CODE_SUCCESS";
export const GET_DETAIL_REQUEST_INVOICE_CODE_FAIL =
  "GET_DETAIL_REQUEST_INVOICE_CODE_FAIL";
export const RESET_DETAIL_REQUEST_INVOICE_CODE =
  "RESET_DETAIL_REQUEST_INVOICE_CODE";

// Tạo Đăng ký sử dụng
export const CREATE_REGISTRY_INVOICES = "CREATE_REGISTRY_INVOICES";
export const CREATE_REGISTRY_INVOICES_SUCCESS =
  "CREATE_REGISTRY_INVOICES_SUCCESS";
export const CREATE_REGISTRY_INVOICES_FAIL = "CREATE_REGISTRY_INVOICES_FAIL";
export const RESET_CREATE_REGISTRY_INVOICES = "RESET_CREATE_REGISTRY_INVOICES";

// EDIT Đăng ký sử dụng
export const EDIT_REGISTRY_INVOICES = "EDIT_REGISTRY_INVOICES";
export const EDIT_REGISTRY_INVOICES_SUCCESS = "EDIT_REGISTRY_INVOICES_SUCCESS";
export const EDIT_REGISTRY_INVOICES_FAIL = "EDIT_REGISTRY_INVOICES_FAIL";
export const RESET_EDIT_REGISTRY_INVOICES = "RESET_EDIT_REGISTRY_INVOICES";

// Tạo Ủy quyền lập hóa đơn
export const CREATE_REGISTRY_DELEGATE = "CREATE_REGISTRY_DELEGATE";
export const CREATE_REGISTRY_DELEGATE_SUCCESS =
  "CREATE_REGISTRY_DELEGATE_SUCCESS";
export const CREATE_REGISTRY_DELEGATE_FAIL = "CREATE_REGISTRY_DELEGATE_FAIL";
export const RESET_CREATE_REGISTRY_DELEGATE = "RESET_CREATE_REGISTRY_DELEGATE";

// EDIT Ủy quyền lập hóa đơn
export const EDIT_REGISTRY_DELEGATE = "EDIT_REGISTRY_DELEGATE";
export const EDIT_REGISTRY_DELEGATE_SUCCESS = "EDIT_REGISTRY_DELEGATE_SUCCESS";
export const EDIT_REGISTRY_DELEGATE_FAIL = "EDIT_REGISTRY_DELEGATE_FAIL";
export const RESET_EDIT_REGISTRY_DELEGATE = "RESET_EDIT_REGISTRY_DELEGATE";

// Tạo Đề nghị cấp HDDT có mã
export const CREATE_REQUEST_INVOICE_CODE = "CREATE_REQUEST_INVOICE_CODE";
export const CREATE_REQUEST_INVOICE_CODE_SUCCESS =
  "CREATE_REQUEST_INVOICE_CODE_SUCCESS";
export const CREATE_REQUEST_INVOICE_CODE_FAIL =
  "CREATE_REQUEST_INVOICE_CODE_FAIL";
export const RESET_CREATE_REQUEST_INVOICE_CODE =
  "RESET_CREATE_REQUEST_INVOICE_CODE";

// EDIT Đề nghị cấp HDDT có mã
export const EDIT_REQUEST_INVOICE_CODE = "EDIT_REQUEST_INVOICE_CODE";
export const EDIT_REQUEST_INVOICE_CODE_SUCCESS =
  "EDIT_REQUEST_INVOICE_CODE_SUCCESS";
export const EDIT_REQUEST_INVOICE_CODE_FAIL = "EDIT_REQUEST_INVOICE_CODE_FAIL";
export const RESET_EDIT_REQUEST_INVOICE_CODE =
  "RESET_EDIT_REQUEST_INVOICE_CODE";

// DOWNLOAD_XML_REGISTRY_INVOICES
export const DOWNLOAD_XML_REGISTRY_INVOICES = "DOWNLOAD_XML_REGISTRY_INVOICES";
export const DOWNLOAD_XML_REGISTRY_INVOICES_SUCCESS =
  "DOWNLOAD_XML_REGISTRY_INVOICES_SUCCESS";
export const DOWNLOAD_XML_REGISTRY_INVOICES_FAIL =
  "DOWNLOAD_XML_REGISTRY_INVOICES_FAIL";
export const RESET_DOWNLOAD_XML_REGISTRY_INVOICES =
  "RESET_DOWNLOAD_XML_REGISTRY_INVOICES";

// DOWNLOAD_XML_REGISTRY_DELEGATE
export const DOWNLOAD_XML_REGISTRY_DELEGATE = "DOWNLOAD_XML_REGISTRY_DELEGATE";
export const DOWNLOAD_XML_REGISTRY_DELEGATE_SUCCESS =
  "DOWNLOAD_XML_REGISTRY_DELEGATE_SUCCESS";
export const DOWNLOAD_XML_REGISTRY_DELEGATE_FAIL =
  "DOWNLOAD_XML_REGISTRY_DELEGATE_FAIL";
export const RESET_DOWNLOAD_XML_REGISTRY_DELEGATE =
  "RESET_DOWNLOAD_XML_REGISTRY_DELEGATE";

// DOWNLOAD_XML_REQUEST_INVOICE_CODE
export const DOWNLOAD_XML_REQUEST_INVOICE_CODE =
  "DOWNLOAD_XML_REQUEST_INVOICE_CODE";
export const DOWNLOAD_XML_REQUEST_INVOICE_CODE_SUCCESS =
  "DOWNLOAD_XML_REQUEST_INVOICE_CODE_SUCCESS";
export const DOWNLOAD_XML_REQUEST_INVOICE_CODE_FAIL =
  "DOWNLOAD_XML_REQUEST_INVOICE_CODE_FAIL";
export const RESET_DOWNLOAD_XML_REQUEST_INVOICE_CODE =
  "RESET_DOWNLOAD_XML_REQUEST_INVOICE_CODE_TYPE";

// Phát hành tờ khai đăng ký sử dụng
export const RELEASE_REGISTRY_INVOICES = "RELEASE_REGISTRY_INVOICES";
export const RELEASE_REGISTRY_INVOICES_SUCCESS =
  "RELEASE_REGISTRY_INVOICES_SUCCESS";
export const RELEASE_REGISTRY_INVOICES_FAIL = "RELEASE_REGISTRY_INVOICES_FAIL";
export const RESET_RELEASE_REGISTRY_INVOICES =
  "RESET_RELEASE_REGISTRY_INVOICES";

// Phát hành Ủy quyền lập hóa đơn
export const RELEASE_REGISTRY_DELEGATE = "RELEASE_REGISTRY_DELEGATE";
export const RELEASE_REGISTRY_DELEGATE_SUCCESS =
  "RELEASE_REGISTRY_DELEGATE_SUCCESS";
export const RELEASE_REGISTRY_DELEGATE_FAIL = "RELEASE_REGISTRY_DELEGATE_FAIL";
export const RESET_RELEASE_REGISTRY_DELEGATE =
  "RESET_RELEASE_REGISTRY_DELEGATE";

// Phát hành ĐỀ NGHỊ CẤP HDDT CÓ MÃ
export const RELEASE_REQUEST_INVOICE_CODE = "RELEASE_REQUEST_INVOICE_CODE";
export const RELEASE_REQUEST_INVOICE_CODE_SUCCESS =
  "RELEASE_REQUEST_INVOICE_CODE_SUCCESS";
export const RELEASE_REQUEST_INVOICE_CODE_FAIL =
  "RELEASE_REQUEST_INVOICE_CODE_FAIL";
export const RESET_RELEASE_REQUEST_INVOICE_CODE =
  "RESET_RELEASE_REQUEST_INVOICE_CODE";
//
export const SET_COLUMN_VISIBLE_REGISTRY_INVOICES =
  "SET_COLUMN_VISIBLE_REGISTRY_INVOICES";

export const SET_COLUMN_VISIBLE_REGISTRY_DELEGATE =
  "SET_COLUMN_VISIBLE_REGISTRY_DELEGATE";

export const SET_COLUMN_VISIBLE_REQUEST_INVOICE_CODE =
  "SET_COLUMN_VISIBLE_REQUEST_INVOICE_CODE";

// PreviewPDf
export const PREVIEW_PDF = "PREVIEW_PDF";
export const PREVIEW_PDF_SUCCESS = "PREVIEW_PDF_SUCCESS";
export const PREVIEW_PDF_FAIL = "PREVIEW_PDF_FAIL";
export const RESET_PREVIEW_FILE = "RESET_PREVIEW_FILE";
//TRANSFER_USB
export const TRANSFER_USB = "TRANSFER_USB";
export const TRANSFER_USB_SUCCESS = "TRANSFER_USB_SUCCESS";
export const TRANSFER_USB_FAIL = "TRANSFER_USB_FAIL";
export const RESET_TRANSFER_USB = "RESET_TRANSFER_USB";

//GET_REASON_DENY_RELEASE
export const GET_REASON_DENY_RELEASE = "GET_REASON_DENY_RELEASE";
export const GET_REASON_DENY_RELEASE_SUCCESS =
  "GET_REASON_DENY_RELEASE_SUCCESS";
export const GET_REASON_DENY_RELEASE_FAIL = "GET_REASON_DENY_RELEASE_FAIL";
export const RESET_GET_REASON_DENY_RELEASE = "RESET_GET_REASON_DENY_RELEASE";

//GET_HISTORY_TRANSFER
export const GET_HISTORY_TRANSFER = "GET_HISTORY_TRANSFER";
export const GET_HISTORY_TRANSFER_SUCCESS = "GET_HISTORY_TRANSFER_SUCCESS";
export const GET_HISTORY_TRANSFER_FAIL = "GET_HISTORY_TRANSFER_FAIL";
export const RESET_GET_HISTORY_TRANSFER = "RESET_GET_HISTORY_TRANSFER";

//CHECK_INVOICES_CURRENT
export const CHECK_INVOICES_CURRENT = "CHECK_INVOICES_CURRENT";
export const CHECK_INVOICES_CURRENT_SUCCESS = "CHECK_INVOICES_CURRENT_SUCCESS";
export const CHECK_INVOICES_CURRENT_FAIL = "CHECK_INVOICES_CURRENT_FAIL";
export const RESET_CHECK_INVOICES_CURRENT = "RESET_CHECK_INVOICES_CURRENT";

// DOWNLOAD REGISTER ENVOICE
export const PREVIEW_PDF_REGISTER_INVOICE = "PREVIEW_PDF_REGISTER_INVOICE";
export const PREVIEW_PDF_REGISTER_INVOICE_SUCCESS = "PREVIEW_PDF_REGISTER_INVOICE_SUCCESS";
export const PREVIEW_PDF_REGISTER_INVOICE_FAIL = "PREVIEW_PDF_REGISTER_INVOICE_FAIL";
export const RESET_PREVIEW_PDF_REGISTER_INVOICE = "RESET_PREVIEW_PDF_REGISTER_INVOICE";

// DOWNLOAD_PDF_REGISTRY_INVOICES
export const DOWNLOAD_PDF_REGISTRY_INVOICES = "DOWNLOAD_PDF_REGISTRY_INVOICES";
export const DOWNLOAD_PDF_REGISTRY_INVOICES_SUCCESS = "DOWNLOAD_PDF_REGISTRY_INVOICES_SUCCESS";
export const DOWNLOAD_PDF_REGISTRY_INVOICES_FAIL = "DOWNLOAD_PDF_REGISTRY_INVOICES_FAIL";
export const RESET_DOWNLOAD_PDF_REGISTRY_INVOICES = "RESET_DOWNLOAD_PDF_REGISTRY_INVOICES";
